import React from 'react';

/**
 * The Follow Up bookmark, in both states, from one source path.
 *
 * The supplied asset is a hollow bookmark: an outer contour followed by an
 * inner counter, which the nonzero fill rule renders as an outline. Truncating
 * it at the first `Z` drops the counter and leaves the solid silhouette — so
 * `filled` is a substring, not a second asset to keep in sync.
 *
 * No `fill` in the source, so `currentColor` makes both variants inherit the
 * caller's text color and stay correct in dark mode.
 */
const OUTER =
  'M17.5,0H6.5A5.507,5.507,0,0,0,1,5.5V20.472a3.5,3.5,0,0,0,6.044,2.4l4.912-5.2,5.013,5.25A3.5,3.5,0,0,0,23,20.51V5.5A5.507,5.507,0,0,0,17.5,0Z';

const COUNTER =
  'M20,20.51a.5.5,0,0,1-.861.345l-6.1-6.391A1.5,1.5,0,0,0,11.95,14h0a1.5,1.5,0,0,0-1.086.47l-6,6.345a.479.479,0,0,1-.549.122A.471.471,0,0,1,4,20.472V5.5A2.5,2.5,0,0,1,6.5,3h11A2.5,2.5,0,0,1,20,5.5Z';

interface BookmarkIconProps {
  /** Solid silhouette when true, hollow outline when false. */
  filled?: boolean;
  className?: string;
}

export const BookmarkIcon: React.FC<BookmarkIconProps> = ({ filled = false, className = 'w-4 h-4' }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    className={className}
    fill="currentColor"
    aria-hidden="true"
    focusable="false"
    data-testid="bookmark-icon"
    data-filled={String(filled)}
  >
    <path d={filled ? OUTER : `${OUTER}${COUNTER}`} />
  </svg>
);

export default BookmarkIcon;
